import React from 'react'
import Button from '../Button/Button'
import InputField from '../InputField/InputField'
import NavList from '../NavList/NavList'

import './Footer.scss'

const Footer = () => {
  return (
    <footer>
      <div className="footer-upper">
        <div className="container">
          <div className="footer-subscribe">
            <div className="footer-subscribe-text">
              <h2>Sign Up To Our Newsletter.</h2>
              <p>Be the first to hear about the latest offers.</p>
            </div>
            <div className="footer-subscribe-form">
              <form>
                <InputField label='Your email' transparent/>
                <Button variant='filled'>Subscribe</Button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-lower">
        <div className="container footer__container">
          <NavList/>
        </div>
      </div>
    </footer>
  )
}

export default Footer